import { HeadCell } from "../ResourcesAutocompleteSearch";
import { IResourceInputGridConfig, IRowsPerPageOptions } from "./Models";
import lang from "./RelationsLang";

export interface IGridResourcesConfig {
    hidden: boolean,

    title: string,

    columns: HeadCell[],
    filters: string,
    labelTemplate?: string,
    descriptionTemplate?: string,

    rowsPerPageOptions: Array<number | { value: number; label: string }>
}

export function createGridConfig(title: string, source: IResourceInputGridConfig, defaultConfig : IGridResourcesConfig): IGridResourcesConfig {
    if (!source)
        return defaultConfig;

    let columns: HeadCell[] = [];
    if (source.columns) {
        for (let key in source.columns) {
            let sourceColumn = source.columns[key];
            columns.push({
                id: key,
                label: lang.getDefaultByPrefixOrFromStrings(sourceColumn, "label", key),
                numeric: sourceColumn.numeric,
                searched: sourceColumn.searched,
                className: sourceColumn.className,
                minWidth: sourceColumn.minWidth,
            })
        }
    }

    if (columns.length == 0)
        columns = defaultConfig.columns;

    return {
        hidden: source.hidden,
        title: !source.title && !source.titlePl && !source.titleEn
            ? lang.getDefaultByPrefixOrFromStrings(source, "title", title)
            : defaultConfig.title,
        columns: columns,
        filters: source.filters ?? "",
        rowsPerPageOptions: parseRowsPerPageOptions(source.rowsPerPageOptions) ?? defaultConfig.rowsPerPageOptions,
        labelTemplate: source.labelTemplate,
        descriptionTemplate: source.descriptionTemplate,
    };
}

function parseRowsPerPageOptions(source: IRowsPerPageOptions): Array<number | { value: number; label: string }> {
    if (!source || source.length == 0)
        return null;

    return source.map((x) => {
        if (typeof x == 'object') {
            return {
                value: x.value,
                label: lang.getDefaultByPrefixOrFromStrings(x, "label")
            }
        }

        return x;
    });
}